import { LitElement, html, css } from 'lit-element';
import { repeat } from "lit-html/directives/repeat.js";
import { classMap } from 'lit-html/directives/class-map';
import '@vaadin/vaadin-date-picker/vaadin-date-picker.js';
import { axios } from '@bundled-es-modules/axios';

class VacationHoldComponent extends LitElement {

    static get properties() {
        return {
            _MainServiceDomain: { type: String },
            _loginDetails: { type: Object },
            _userDetails: { type: Object },
            _subscriptionDetails: { type: Object },
            _vacationStopDate: { type: Date },
            _vacationStartDate: { type: Date },
            _dispositionOptions: { type: Array },
            _vacationHoldErrorRes: { type: Object },
            _openVacationHoldForm: { type: Boolean },
            _currentVacationHoldDetails: { type: Object },
            _setDispositionForCurrentHold: { type: Boolean },
            _resumeMinDate: { type: Date },
            vacationStopDateVaadin: { type: Date },
            vacationStartDateVaadin: { type: Date },
            isSystemError: { type: Boolean },
        }
    }

    get MainServiceDomain() {
        return this._MainServiceDomain;
    }

    set MainServiceDomain(value) {
        this._MainServiceDomain = value;
    }

    get loginDetails() {
        return this._loginDetails;
    }

    set loginDetails(value) {
        this._loginDetails = value;
    }

    get userDetails() {
        return this._userDetails;
    }

    set userDetails(value) {
        this._userDetails = value;
    }

    get subscriptionDetails() {
        return this._subscriptionDetails;
    }

    set subscriptionDetails(value) {
        this._subscriptionDetails = value;
    }

    get vacationStopDate() {
        return this._vacationStopDate;
    }

    set vacationStopDate(value) {
        this._vacationStopDate = value;
    }

    get vacationStartDate() {
        return this._vacationStartDate;
    }

    set vacationStartDate(value) {
        this._vacationStartDate = value;
    }

    get dispositionOptions() {
        return this._dispositionOptions;
    }

    set dispositionOptions(value) {
        this._dispositionOptions = value;
    }

    get openVacationHoldForm() {
        return this._openVacationHoldForm;
    }

    set openVacationHoldForm(value) {
        this._openVacationHoldForm = value;
    }

    get currentVacationHoldDetails() {
        return this._currentVacationHoldDetails;
    }

    set currentVacationHoldDetails(value) {
        this._currentVacationHoldDetails = value;
    }

    get setDispositionForCurrentHold() {
        return this._setDispositionForCurrentHold;
    }

    set setDispositionForCurrentHold(value) {
        this._setDispositionForCurrentHold = value;
    }

    get resumeMinDate() {
        return this._resumeMinDate;
    }

    set resumeMinDate(value) {
        this._resumeMinDate = value;
    }

    get vacationHoldErrorRes() {
        return this._vacationHoldErrorRes;
    }

    set vacationHoldErrorRes(value) {
        this._vacationHoldErrorRes = value;
    }

    constructor() {
        super();
        this.isSystemError = false;
        this.openVacationHoldForm = false;
        this.setDispositionForCurrentHold = true;
        this.currentVacationHoldDetails = undefined;
        document.addEventListener('onSelectSubscription', async(e) => {
            this.vacationHoldErrorRes = '';
            this.openVacationHoldForm = false;

            this.loginDetails = e.detail.loginDetails;
            this.subscriptionDetails = e.detail.selectedSubscription;
            this.userDetails = e.detail.userDetails;

            const vacRes = await this.getCurrentVacationHold(this.subscriptionDetails.subscriptionId);
            if (vacRes.length) {
                this.currentVacationHoldDetails = vacRes[0];
            } else {
                this.currentVacationHoldDetails = undefined;
            }
            this.dispositionOptions = await this.getDispositionOptions();
        })
    }

    updated() {
        if (this.setDispositionForCurrentHold) {
            if (this.openVacationHoldForm) {
                this.setDispositionForCurrentHold = false;

                if (this.currentVacationHoldDetails != undefined) {
                    this.vacationStopDate = this.dateFormatForDisplay(this.currentVacationHoldDetails.holdDate);
                    this.vacationStartDate = this.dateFormatForDisplay(this.currentVacationHoldDetails.resumeDate);
                    this.vacationStopDateVaadin = this.dateFormatForVaadin(this.currentVacationHoldDetails.holdDate);
                    this.vacationStartDateVaadin = this.dateFormatForVaadin(this.currentVacationHoldDetails.resumeDate);
                    this.resumeMinDate = this.vacationStopDateVaadin;
                    this.shadowRoot.getElementById(this.currentVacationHoldDetails.holdDisposition + "-option").checked = true;
                } else {
                    this.vacationStopDate = this.dateFormatForDisplay(new Date(Date.now() + 86400000));
                    this.vacationStartDate = this.dateFormatForDisplay(new Date(Date.now() + 86400000 * 2));
                    this.vacationStopDateVaadin = this.dateFormatForVaadin(new Date(Date.now() + 86400000));
                    this.vacationStartDateVaadin = this.dateFormatForVaadin(new Date(Date.now() + 86400000 * 2));
                    this.resumeMinDate = this.vacationStopDateVaadin;
                }
            } else {
                if (this.currentVacationHoldDetails != undefined) {
                    this.vacationStopDate = this.dateFormatForDisplay(this.currentVacationHoldDetails.holdDate);
                    this.vacationStartDate = this.dateFormatForDisplay(this.currentVacationHoldDetails.resumeDate);
                }
            }
        }
    }

    static get styles() {
        return css `
        * {
            margin: 0;
            padding: 0;
        }
        .text-center {
            text-align: center;
        }
        
        .d-none {
            display: none;
        }
        
        .d-block {
            display: block;
        }
        
        .mg-b5 {
            margin-bottom: 5px;
        }
        
        .mg-t5 {
            margin-top: 5px;
        }
        
        p {
            font-size: 14px;
        }

        .width100 {
            width: 100%;
        }

        .disabled {
            opacity: 0.5;
            pointer-events: none;
            cursor: not-allowed;
            position: relative;
        }

        /* Element Style */
        .vacation-box {
            border-radius: 35px;
            position: relative;
            padding: 25px 25px;
            width: 100%;
            border: 1px solid var(--w-bg-borc, #505050);
            background-color: var(--w-bgc, #fff);
            box-sizing: border-box;
        }
        
        .vacation-heading {
            font-size: var(--w-tit-fs, 14px);
            color: var(--w-tit-col, #000);
            background-color: var(--w-tit-bgc, #fff);
            padding: 10px;
            border-radius: 5px;
        }
        
        .vacation-selected {
            color: var(--vacation-heading-Color, #000);
            background-color: var(--vacation-heading-bgColor, #fff);
            border: none;
            padding: 10px;
            border-radius: 5px;
        }
        
        .btn {
            display: inline-block;
            font-weight: 400;
            text-align: center;
            white-space: nowrap;
            vertical-align: middle;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            border: 1px solid transparent;
            padding: 6px 12px;
            font-size: 16;
            line-height: 1.5;
            border-radius: 4px;
        }
        
        .btn:hover, .btn:focus {
            text-decoration: none;
        }
          
        .btn:focus, .btn.focus {
            outline: 0;
            box-shadow: none;
        }
          
        .btn.disabled, .btn:disabled {
            opacity: 0.65;
        }
        
        .btn-success {
            color: var(--w-btn-col, #505050);
            background-color: var(--w-btn-bgc, #fff);
            border: 1px solid var(--w-btn-borc, #505050);
            font-size: var(--w-btn-fs, 15px);
            cursor: pointer;
        }
        
        .btn-success:hover {
            color: var(--w-btn-col, #fff);
            background-color: var(--w-btn-bgc, #505050);
            border: 1px solid var(--w-btn-borc, #505050);
            font-size: var(--w-btn-fs, 14px);
            cursor: pointer;
        }
        
        
        .btn-lg {
            padding: 8px 16px;
            font-size: 14px;
            line-height: 1.5;
            border-radius: 4px;
        }
        
        .btn-block {
            display: block;
            width: 100%;
        }
        
        .form-group {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
            flex: 0 0 auto;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-flow: row wrap;
            flex-flow: row wrap;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            margin-bottom: 0;
            color: var(--form-group-color, #fff);
        }
        
        .form-control {
            display: block;
            width: 100%;
            padding: 8px 12px;
            font-size: 14px;
            line-height: 1.5;
            color: var(--form-control-color, #000);
            background-color: var(--form-control-bgColor, #fff);
            border: 1px solid var(--form-control-borderColor, #000);
            background-clip: padding-box;
            border-radius: 4px;
        }
        
        .form-control:focus {
            color: var(--form-control-focus-color, #495057);
            background-color: var(--form-control-focus-bgColor, #fff);
            border-color: var(--form-control-borderColor, #80bdff);
            outline: 0;
            box-shadow: 0 0 0 0.2rem var(--form-control-focus-boxShadow, rgba(65, 157, 255, 0.25));
          }
        
        
        .form-control::-webkit-input-placeholder {
            color: var(--form-control-placehorderColor, #959595);
            opacity: 1;
        }
        
        .form-control::-moz-placeholder {
            color: var(--form-control-placeholderColor, #959595);
            opacity: 1;
        }
        
        .form-control:-ms-input-placeholder {
            color: var(--form-control-placeholderColor, #959595);
            opacity: 1;
        }
        
        .form-control::-ms-input-placeholder {
            color: var(--form-control-placeholderColor, #959595);
            opacity: 1;
        }
        
        .form-control::placeholder {
            color: var(--form-control-placeholderColor, #959595);
            opacity: 1;
        }
        
        
        .custom-radio .custom-radioBox {
            list-style: none;
            margin: 0;
            padding: 0;
        }
        
        .custom-radioBox .custom-radioInner {
            color: var(--custom-radioInner-color, #000);
            display: flex;
            align-items: center;
            position: relative;
            margin: 5px 0;
        }
        
        .custom-radioBox .custom-radioInner input[type=radio]{
            position: absolute;
            opacity: 0;
            width: 100%;
            height: 100%;
        }
        
        .custom-radioBox .custom-radioInner label{
            position: relative;
            font-weight: 300;
            font-size: 14px;
            padding: 0 30px;
            margin: 0;
            z-index: 9;
            cursor: pointer;
        }
        
        .custom-radioBox .custom-radioInner .check{
            position: absolute;
            border: 1px solid var(--widget-radio-border, #d3d3d3);
            background-color: var(--widget-radio-bgColor, #fff);
            border-radius: 100%;
            height: 20px;
            width: 20px;
            top: 50%;
            transform: translateY(-50%);
            left: 0px;
            z-index: 5;
        }
        
        .custom-radioBox .custom-radioInner .check::before {
            position: absolute;
            content: '';
            border-radius: 100%;
            height: 16px;
            width: 16px;
            top: 50%;
            transform: translateY(-50%);
            left: 2px;
            margin: auto;
        }
        
        input[type=radio]:checked ~ .check {
            border: 1px solid var(--widget-radioChecked-border, #d3d3d3);
            background-color: var(--widget-radioChecked-bgColor, rgb(236, 240, 241));
        }
        
        input[type=radio]:checked ~ .check::before{
            background-color: var(--widget-radioChecked-bgColor, rgb(236, 240, 241));
        }

        .error {
            font-size: var(--w-msg-fs, 13px);
            color: var(--w-msg-col, #000);
        }

        .error-text-color {
            color: var(--w-err-sys-col, red);
        }
        @media(max-width: 767px){
            .vacation-box {
                padding: 15px;
                border-radius: 20px;
            }
        }
        `;
    }

    render() {
            return html `
        <div id="vacation-hold-widget" class=${classMap({ 'vacation-box': true, 'disabled': this.subscriptionDetails ? (this.subscriptionDetails.status === 'Inactive' || this.subscriptionDetails.type === 'Digital') : false })} >
        <div class="text-center mg-b5">
            <h2 class="vacation-heading">Vacation Stop</h2>
        </div>
        
        ${this.openVacationHoldForm ? html`<div id="vacation-hold-form" class="vacation-expand-div">
          <vaadin-date-picker class="width100" id="vacation-stop-date" placeholder="Stop Date" min=${this.dateFormatForVaadin(new Date(Date.now() + 86400000))} @change=${this.updateStopDate} value=${this.vacationStopDateVaadin}>
           </vaadin-date-picker>
          <vaadin-date-picker class="width100" id="vacation-start-date" placeholder="Resume Date" min=${this.resumeMinDate} @change=${this.updateStartDate} value=${this.vacationStartDateVaadin}>
           </vaadin-date-picker>
            <div class="vacation-selected text-center mg-t5">
                <p>You have selected:</p>
                <p>Hold ${this.vacationStopDate}</p>
                <p>Start ${this.vacationStartDate}</p>
            </div>
            <div id="vacation-hold-radios" class="custom-radio mg-t5">
                ${this.dispositionOptions ? html`<ul class="custom-radioBox mg-t5">
                    ${repeat(this.dispositionOptions, (item, idx) => html`
                    <li class="custom-radioInner">
                      <input type="radio" id="${item.code}-option" name="vacation-hold-selector" value=${item.code}>
                      <label for="${item.code}-option">${item.description}</label>
                      <div class="check"></div>
                    </li>`
        )}` : html``}
                </ul>
            </div>
            <div class="text-center">
                <button type="submit" class="btn btn-success btn-lg btn-block mg-t5" @click="${this.submitVacationHold}">Done</button>
                <div>${this.setErrorMessage()}</div>
                <button type="submit" class="btn btn-success btn-lg btn-block mg-t5" @click="${this.stopVacHoldEdit}">Close</button>
            </div>
        </div>` : html`
        ${this.currentVacationHoldDetails ? html`<div class="vacation-selected text-center mg-t5">
                <p>Your current hold:</p>
                <p>Stop ${this.dateFormatForDisplay(this.currentVacationHoldDetails.holdDate)}</p>
                <p>Start ${this.dateFormatForDisplay(this.currentVacationHoldDetails.resumeDate)}</p>
        </div>
        <div class="text-center">
                <button type="submit" class="btn btn-success btn-block btn-lg mg-t5" @click=${this.openVacationHold}>Edit</button>
                <div class="vacation-selected text-center mg-t5">
                  <p>Please contact Customer Service (number at the bottom of your screen) if you need to cancel your current vacation stop
                  </p>
                </div>
            </div>` : html`
        <div id="temp-hold-btn">
        <button type="submit" class="btn btn-success btn-lg btn-block mg-b5" @click="${this.openVacationHold}">Set A Temporary Hold</button>
        </div>`}`}
    </div>`
    }

    dateFormat(inputDate) {

        let date = new Date(inputDate);
        inputDate = new Date(inputDate);

        date.setMonth(inputDate.getUTCMonth(), inputDate.getUTCDate());
        date.setFullYear(inputDate.getUTCFullYear());
        date.setHours(inputDate.getUTCHours());
        date.setMinutes(inputDate.getUTCMinutes());
        date.setSeconds(inputDate.getUTCSeconds());
        date.setMilliseconds(inputDate.getUTCMilliseconds());

        return date;
    }

    dateFormatForDisplay(inputDate) {
        const date = this.dateFormat(inputDate)
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }

    dateFormatForVaadin(inputDate) {
        const date = this.dateFormat(inputDate)
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }

    async openVacationHold() {

        if (this.subscriptionDetails) {
            this.openVacationHoldForm = true;
            this.setDispositionForCurrentHold = true;
        }
    }

    async getDispositionOptions() {
        try {

            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${this.loginDetails.token}`,
            }

            const dispositionOptions = await axios.get(`${this.MainServiceDomain}/appservices/api/v2/vachold/dispositions`, {
                headers: headers
            });

            return dispositionOptions.data;
        } catch (error) {
            throw error;
        }
    }

    async getCurrentVacationHold(subscriptionId) {
        try {
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${this.loginDetails.token}`,
            }

            const currentHold = await axios.get(`${this.MainServiceDomain}/appservices/api/v2/subscription/${subscriptionId}/vachold?limit=1`, {
                headers: headers
            });

            return currentHold.data;

        } catch (error) {
            console.log(error);
            return error;
        }
    }

    async updateStopDate() {
        this.vacationStopDate = this.dateFormatForDisplay(this.shadowRoot.getElementById("vacation-stop-date").value);
        this.vacationStopDateVaadin = this.dateFormatForVaadin(this.shadowRoot.getElementById("vacation-stop-date").value);
        this.resumeMinDate = this.dateFormatForVaadin(new Date(this.shadowRoot.getElementById("vacation-stop-date").value).getTime() + 86400000);
        await this.requestUpdate();
    }

    async updateStartDate() {
        this.vacationStartDate = this.dateFormatForDisplay(this.shadowRoot.getElementById("vacation-start-date").value);
        this.vacationStartDateVaadin = this.dateFormatForVaadin(this.shadowRoot.getElementById("vacation-start-date").value);
        await this.requestUpdate();
    }

    async submitVacationHold() {
        this.vacationHoldErrorRes = '';
        this.isSystemError = false;
        const radios = this.shadowRoot.getElementById("vacation-hold-radios").getElementsByTagName("input");
        let val = undefined;
        for (var i = 0, len = radios.length; i < len; i++) {
            if (radios[i].checked) {
                val = radios[i].value;
                break;
            }
        }
        await this.requestUpdate();

        let detail = null;
        if (val) {
            if (!this.currentVacationHoldDetails) {
                detail = {
                    isEdit: false,
                    subscriptionId: this.subscriptionDetails.subscriptionId,
                    vacationStopDate: this.vacationStopDate,
                    vacationStartDate: this.vacationStartDate,
                    HoldDisposition: val,
                }
            } else {
                detail = {
                    vacationHoldId: this.currentVacationHoldDetails.vacationHoldId,
                    isEdit: true,
                    subscriptionId: this.subscriptionDetails.subscriptionId,
                    vacationStopDate: this.vacationStopDate,
                    vacationStartDate: this.vacationStartDate,
                    HoldDisposition: val,
                }
            }
            this.onSubmitVacationHold(detail).then(
                async (res) => {
                    if (res.status === 204 || !!res.data.vacationHoldId) {

                        const vacRes = await this.getCurrentVacationHold(detail.subscriptionId);

                        if (vacRes.length) {
                            this.currentVacationHoldDetails = vacRes[0];
                        } else {
                            this.currentVacationHoldDetails = undefined;
                        }
                        this.openVacationHoldForm = false;
                        this.setDispositionForCurrentHold = true;
                    } else {
                        if (res.data && res.status != 500) {
                            this.vacationHoldErrorRes = res.data;
                        } else {
                            this.isSystemError = true;
                            this.vacationHoldErrorRes = 'System is temporarily unavailable, please try again later';
                        }
                        this.openVacationHoldForm = true;
                        this.setDispositionForCurrentHold = false;
                    }
                })
        } else {
            this.vacationHoldErrorRes = 'Please select a hold disposition.';
        }
    }

    async onSubmitVacationHold(detail) {
        let res = null;
        try {
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${this.loginDetails.token}`,
            }

            const body = `HoldDate=${detail.vacationStopDate}&ResumeDate=${detail.vacationStartDate}&HoldDisposition=${detail.HoldDisposition}`;

            if (detail.isEdit) {
                res = await axios.put(`${this.MainServiceDomain}/appservices/api/v2/subscription/${detail.subscriptionId}/vachold/${detail.vacationHoldId}`, body, {
                    headers: headers
                });
            } else {
                res = await axios.post(`${this.MainServiceDomain}/appservices/api/v2/subscription/${detail.subscriptionId}/vachold`, body, {
                    headers: headers
                });
            }

            return res;

        } catch (error) {
            console.log(error);
            return error.response;
        }
    }

    stopVacHoldEdit() {
        this.openVacationHoldForm = false;
        this.setDispositionForCurrentHold = true;
        this.vacationHoldErrorRes = '';
    }

    async deleteCurrentHold() {
        try {
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${this.loginDetails.token}`,
            }

            const res = await axios.delete(`${this.MainServiceDomain}/appservices/api/v2/subscription/${this.subscriptionDetails.subscriptionId}/vachold/${this.currentVacationHoldDetails.vacationHoldId}`, {
                headers: headers
            });

            if (res.status == 204) {
                const vacRes = await this.getCurrentVacationHold(this.subscriptionDetails.subscriptionId);

                if (vacRes.length) {
                    this.currentVacationHoldDetails = vacRes[0];
                } else {
                    this.currentVacationHoldDetails = undefined;
                }
            } else {
                console.log("Something went wrong.");
            }

            return res;

        } catch (error) {
            throw error;
        }
    }

    setErrorMessage() {
        let message = [];
        if (this.vacationHoldErrorRes && this.vacationHoldErrorRes != '') {
            if (typeof this.vacationHoldErrorRes == 'string') {
                message.push(this.vacationHoldErrorRes);
            }
            if (this.vacationHoldErrorRes.message) {
                message.push(this.vacationHoldErrorRes.message);
            }
            if (this.vacationHoldErrorRes.modelState) {
                if (this.vacationHoldErrorRes.modelState.request && this.vacationHoldErrorRes.modelState.request.length > 0) {
                    message.push(this.vacationHoldErrorRes.modelState['request'].map(item => item));
                }
                if (this.vacationHoldErrorRes.modelState['request.HoldDate']) {
                    message.push(this.vacationHoldErrorRes.modelState['request.HoldDate'].map(item => item));
                }
                if (this.vacationHoldErrorRes.modelState['request.ResumeDate']) {
                    message.push(this.vacationHoldErrorRes.modelState['request.ResumeDate'].map(item => item));
                }
            }
            return message.map(item => html`<p class=${classMap({ 'error': true, 'error-text-color': this.isSystemError })}>${item}</p>`);
        }
        return '';
    }
}

customElements.define('syncui-vacation-hold', VacationHoldComponent);